export default "__VITE_ASSET__DbMj657l__"